// frontend/src/types/quiz.types.ts

export type QuestionType = 'multiple_choice' | 'fill_blank' | 'code_completion' | 'find_bug';
export type QuizDifficulty = 'easy' | 'medium' | 'hard';

/** Backend'den gelen, doğru cevabı İÇERMEYEN soru. */
export interface QuizQuestionPublic {
  id: string;
  type: QuestionType;
  question: string;
  options: string[];
}

export interface ActiveQuiz {
  quizId: string;
  title: string;
  questions: QuizQuestionPublic[];
}

export interface QuizResultItem {
  questionId: string;
  correct: boolean;
  correctAnswer: string;
  explanation: string;
}

export interface QuizResult {
  score: number;
  correctCount: number;
  totalCount: number;
  xpAwarded: number;
  results: QuizResultItem[];
}

export interface QuizStats {
  totalQuizzes: number;
  averageScore: number;
}

export const DIFFICULTY_LABEL: Record<QuizDifficulty, { label: string; icon: string; description: string }> = {
  easy: { label: 'Başlangıç', icon: '🌱', description: 'Temel kavramlar' },
  medium: { label: 'Orta', icon: '🚀', description: 'Uygulamalı sorular' },
  hard: { label: 'İleri', icon: '🔥', description: 'Zorlayıcı sorular' },
};
